var render = function render(){var _vm=this,_c=_vm._self._c;return (Number(_vm.number) !== 0 && Number(_vm.number) < _vm.dp)?_c('div',{staticStyle:{"display":"inline"}},[_c('el-tooltip',{attrs:{"content":`${_vm.number}`,"placement":"top"}},[_c('i',{staticClass:"el-icon-info",staticStyle:{"font-size":"12px"}})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }